module.exports = __webpack_public_path__ + "static/media/cashier64.55992671.png";